import { io } from "socket.io-client";
import { insertEditorInstancesDelta, loadSignatures, setEditorSummary, setIsChangeByUser, setIsExternalAllow, setServerData } from "./app/EditorSlice";
import { adjustEditorHeightWithSignatures, isRespectiveDocument, showPagebreak, safeParseEditorState } from "./utils/helper";
import { padServices } from "./api";
import { $generateHtmlFromNodes } from '@lexical/html';

// const URL = "https://pad.workw.com/";
// const URL = 'http://192.168.18.98:3100'

//Added local Socket Server for Testing
// const URL = "http://localhost:3100";
const URL = "https://pad.workw.com";

const socket = io(URL);
// emitters


export const emitLoadData = (data) => {
  socket.emit("load-data", data);
};

export const listenLoadData = (editor, dispatch) => {
  socket.off("load-data").on("load-data", ({ type, data, documentId }) => {
    if (!type || !data || !documentId) return console.error("okkInvalid data received");
    if (isRespectiveDocument(documentId)) {
      try {
        if (type === "editor") {
          dispatch(setIsChangeByUser(false));
          editor.update(() => editor.setEditorState(safeParseEditorState(editor, data)));
        } else if (type === "summary") {
          dispatch(setEditorSummary(data));
        } else if (type === "signature") {
          dispatch(loadSignatures(data));
        }
      } catch (error) {
        console.error(`Error processing ${type}:`, error);
      }
    }
  });
};

// Emitters for Chat Implemented here
export const emitLiveComments = (data) => {
  socket.emit("comments", data);
};

//Emits mouse coordinates to the server.
export const emitMousePositions = (obj) => {
  socket.emit("mouse-positions", obj);
};

// //Emits mouse coordinates to the server.

export const emitRoomID = (roomID) => {
  socket.emit("room-id", roomID);
}
// // listeners
// // listeners
// export const ListenLoadData = (callback) => {
//   socket.on("load-data", () => {
//     callback();
//   });
// };
export const renderMouse = (setConnectedSocketID) => {
  socket.on("mouse-positions", (info) => {
    setConnectedSocketID(info);
  });
};
export const addTotalClients = (setNumberOfConnectedClients) => {
  socket.on("total-clients", (totalClients) => {
    setNumberOfConnectedClients(totalClients);
  });
};

export const connectedClients = (setConnectedSocketID) => {
  socket.on("connected-clients-ids", (connectedClientArr) => {
    // console.log(connectedClientArr);
    setConnectedSocketID(connectedClientArr);
  });
};

export const removeTotalClients = (setNumberOfConnectedClients) => {
  socket.on("disonnected-client", (totalClients) => {
    setNumberOfConnectedClients(totalClients);
  });
};


const updateScroll = () => {
  var element = document.getElementById("myChat");
  element.scrollTop = element.scrollHeight;
};
// //Listener for Chats
export const listenerLiveComments = (updateMessageList) => {
  socket.on("comments", (data) => {
    data.color = "#98b3e6";
    data.margin = "5px auto 5px 0px"; //this styling work should be done through id
    updateMessageList(data);
    updateScroll()
  });
};
// export const listenerLiveComments = (updateMessageList) => {
//   socket.on("comments", (data) => {
//     data.color = "#98b3e6";
//     data.margin = "5px auto 5px 0px"; //this styling work should be done through id
//     updateMessageList(data);
//   });
// };

export const emitUpdateAll = (data) => {
  socket.emit('bulk-change', data)
}

export const listenUpdateAll = (id, editor, dispatch) => {

  const loadDataIntoEditor = (data) => {
    if (!data?.milepadData || !data?.summary || !data?.Signatures) {
      return;
    }
    const initialState = safeParseEditorState(editor, data?.milepadData);
    const signatures = data?.Signatures;
    editor.setEditorState(initialState);
    dispatch(loadSignatures(signatures));
    adjustEditorHeightWithSignatures(signatures);
    showPagebreak();
    const htmlContent = initialState.read(() => $generateHtmlFromNodes(editor, null));
    if (htmlContent) {
      dispatch(insertEditorInstancesDelta(htmlContent));
    }
    dispatch(setIsExternalAllow(data?.isExternal || false));
    dispatch(setEditorSummary(data?.summary));
  };

  socket.on("bulk-change", async (data) => {
    try {
      const serverResponse = await padServices.fetchById(id);
      if (serverResponse) {
        let dataToLoad = {
          ...serverResponse?.data,
          summary: serverResponse?.data?.summary || "",
          Signatures: serverResponse?.data?.Signatures || [],
          milepadData: serverResponse?.data?.milepadData || "",
        };
        dispatch(setServerData(dataToLoad));
        loadDataIntoEditor(dataToLoad);
      }

    } catch (error) {
      console.error("Error updating board from bulk-change:", error);
    }
  });
};

export default socket;
